// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('agencySettings', ['$http', 'obexConstant', 'authService',
    function($http, obexConstant, authService) {
      return {
        //Get agency id
        getAgencyById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        //GET time ZONE
        getWindowsTimeZones() {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlWindowsTimeZones}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        //Update agency
        updateAgency(id, organization) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlOrganization}/${id}`;
            return $http.put(url, organization, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/agencySettings.service.js